import React, { useCallback, useMemo, useState } from 'react';
import {
  ITab,
  OutboundCallModal,
  OutboundCallModalProvider,
  TabNameEnum,
} from '@app/layouts/MainLayout/components/OutboundCall';
import { TransferringCallConfirmation } from './TransferringCallConfirmation';
import { TransferringCallProvider } from './context';
import { inboxLocators } from '@locators/inbox';
import { FeatureFlagKeys, useFeatureFlags } from '@modules/FeatureFlagModule';

type TransferringCallProps = {
  task: any;
  onClose: () => void;
};

export const TransferringCall: React.FC<TransferringCallProps> = ({
  task,
  onClose,
}) => {
  const [activeStep, setActiveStep] = useState(0);
  const {
    [FeatureFlagKeys.featureInboxCallTransferToAgent]:
      featureInboxCallTransferToAgent,
    [FeatureFlagKeys.featureInboxCallTransferToQueue]:
      featureInboxCallTransferToQueue,
  } = useFeatureFlags();

  const callModalTabs = useMemo(() => {
    const tabs: ITab[] = [
      {
        value: TabNameEnum.Employees,
        disabled: !featureInboxCallTransferToAgent,
        selected: !!featureInboxCallTransferToAgent,
      },
      {
        value: TabNameEnum.Keypad,
        selected: !featureInboxCallTransferToAgent,
      },
    ];

    if (featureInboxCallTransferToQueue) {
      tabs.splice(1, 0, {
        value: TabNameEnum.Queue,
      });
    }

    return tabs;
  }, [featureInboxCallTransferToAgent, featureInboxCallTransferToQueue]);

  const handleNext = useCallback(() => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  }, []);

  const handleBack = useCallback(() => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  }, []);

  const cancelTransfer = useCallback(() => {
    onClose?.();
  }, [onClose]);

  return (
    <OutboundCallModalProvider>
      <TransferringCallProvider task={task} onClose={onClose}>
        <div>
          <OutboundCallModal
            open={activeStep === 0}
            setOpen={cancelTransfer}
            title={'Transfer a Call'}
            id={inboxLocators.callBar.transferModal}
            tabs={callModalTabs}
            actionButton={{
              text: 'Next',
              onClick: handleNext,
            }}
            onClose={cancelTransfer}
            animate={false}
          />
          {activeStep === 1 && (
            <TransferringCallConfirmation handleBack={handleBack} />
          )}
        </div>
      </TransferringCallProvider>
    </OutboundCallModalProvider>
  );
};
